import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import {
  IEpGridModel, EpGridEvent, IEpGridSelectionOptions, IEpGridColumn,
  EpDataViewModelService, EpGridComponent, IEpGridState, IEPGridDataResult,
  EpButtonStyle, IEpComponentEventArg, EpShellService, EpEventService
} from '@epicor/kinetic';
import { IEpBtFaCardModel } from '../../models/epbt-fa-card.model';
import {
  GetCustomerNotepadItemsRequest, PagingParameters, SortParameters,
  FieldAgentClient, GetQuotesRequest,
  PortalSearchParametersSuper, DocumentRequestParametersDocumentType, Opportunity
} from 'ep-bt-field-agent-proxy';
import { BistrackConfig, DateFormats, DocumentTypes, ModelType, GridFieldType, CustomEvents, SearchPageNames, SearchPlaceHolderText, DefaultDocFilterType, Right } from 'ep-bt-controls';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';
import { EpbtFaAttachmentService } from '../../services/epbt-fa-attachment.service';
import { Observable, from } from 'rxjs';
import { QuickOrderModel } from '../../models/quick-order.model';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { EpbtFaQuickOrderService } from '../../services/epbt-fa-quick-order.service';
import { EpbtFaFilterService } from '../../services/epbt-fa-filter.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaCustomerSearchComponent } from '../../controls/epbt-fa-customer-search/epbt-fa-customer-search.component';
import { EpbtFaOpportunityService } from '../../services/epbt-fa-opportunity.service';



declare var $: any;


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-documents-grid',
  templateUrl: './epbt-fa-documents-grid.component.html',
  styleUrls: ['./epbt-fa-documents-grid.component.scss']
})
export class EpbtFaDocumentsGridComponent implements OnInit, OnChanges {
  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }
  get searchString(): string { return this._searchString; }

  constructor(private client: FieldAgentClient, private route: ActivatedRoute,
    private router: Router, private fieldAgentService: EpbtFieldAgentService,
    private config: BistrackConfig, private faDocumentService: EpbtFaDocumentService,
    private faDocumentPDFService: EpbtFaAttachmentService,
    public quickOrderService: EpbtFaQuickOrderService,
    private customerService: EpbtFaCustomerService, private opportunityService: EpbtFaOpportunityService,
    private epEvent: EpEventService, private filterService: EpbtFaFilterService,
    private sortService: EpbtFaSortService) {
    this.epEvent.onEvents([CustomEvents.CustomerDocumentSearch]).subscribe(event => {
      console.log(event);
      const docType = this.faDocumentService.fromDashbard ? this.faDocumentService.selectedDocumentTypeForDash : this.faDocumentService.selectedDocumentType;
      if (docType == this.documentTypes.Statements || docType == this.documentTypes.CallOffOrders) {
        if (this.faDocumentService.fromDashbard) {
          this.updateSearchEventsData(event.data);
        } else if (this.documentTypes.Statements && event.data == 'StatementSort') {
          this.updateSearchEventsData('');
 } else {
          this.navigateToCustomer();
 }
      } else {
        this.updateSearchEventsData(event.data);
      }
    });
  }

  // @Input() currentCustomer: any;
  EpButtonStyle = EpButtonStyle;
  @Input() customerId: number;
  @Input() fromDashbard = false;
  addVisibility = true;
  addButtonTitle = 'ADD OPPORTUNITY';
  documentPdfData: any;

  private _searchString: string = undefined;

  @ViewChild('dateTemplate', { static: false }) dateTemplate: TemplateRef<any>;
  @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
  @ViewChild('percentageTemplate', { static: true }) percentageTemplate: TemplateRef<any>;
  @ViewChild('downloadPDFDocumentCellTemplate', { static: false }) downloadPDFTemplate: TemplateRef<any>;
  @ViewChild('noCommaTemplate', { static: false }) noCommaTemplate: TemplateRef<any>;
  @ViewChild(EpbtFaCustomerSearchComponent, { static: false }) searchComponent: EpbtFaCustomerSearchComponent;

  public gridModel: IEpGridModel;
  public pageSize = 10;
  public card: Array<IEpBtFaCardModel>;

  webTrackUser: any;
  customerNotepadItemsRequest: GetCustomerNotepadItemsRequest; // Need to change to documents
  getQuotesRequest: GetQuotesRequest;
  paging: PagingParameters;
  sort: SortParameters;
  searchParameters: PortalSearchParametersSuper;
  webtrackResult: any;
  documents: any = [];
  currency: string;
  dateFormat: string;
  gridColumns: IEpGridColumn[];
  documentType: string;
  documentTypes = DocumentTypes;

  fieldTypeEnum: any = GridFieldType;
  @Output() documentTypeChange = new EventEmitter<any>();

  // for paging
  @Output() loadingChange = new EventEmitter<boolean>();
  documentsCollection: any = [];
  totalPages = 1;
  showGrid = true;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;
  // for search and filter
  pageName: string;
  placeholder: string;
  isFilter = true;
  isSort = true;

  values = {
    check: true,
    unCheck: false
  };

  receiveString(searchValue) {
    this.searchString = searchValue;
    // this.filterService.opportunitySearchValue = searchString.firstChange ? this.filterService.opportunitySearchValue : searchString.currentValue;

  }

  ngOnChanges(changes: SimpleChanges) {
    // const searchString: SimpleChange = changes.searchString;
    // console.log(this.pageName);
    // if (searchString) {
    //   searchString.firstChange
    // }
  }

  ngOnInit() {
    // this.documentTypes.Stocktransfers
    this.faDocumentService.fromDashbard = this.fromDashbard;
    console.log('From Dashboard', this.faDocumentService.fromDashbard);
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.currency = bistrackSettings.baseCurrency.symbol;
      this.dateFormat = bistrackSettings.shortDateFormat ? bistrackSettings.shortDateFormat : DateFormats.ShortDate;
      this.pageSize = bistrackSettings.searchPageSize;
      // this.documentType = !this.fromDashbard ? this.faDocumentService.selectedDocumentType : this.faDocumentService.selectedDocumentTypeForDash;
    });
  }

  onEnterClick() {
    console.log(event);
    const docType = this.faDocumentService.fromDashbard ? this.faDocumentService.selectedDocumentTypeForDash : this.faDocumentService.selectedDocumentType;
    if (docType == this.documentTypes.Statements || docType == this.documentTypes.CallOffOrders) {
      if (this.faDocumentService.fromDashbard) {
        this.updateSearchEventsData(this.searchString);
      } else if (this.documentTypes.Statements && this.faDocumentService.fromDashbard) {
        this.updateSearchEventsData('');
 } else {
        this.navigateToCustomer();
 }
    } else {
      this.updateSearchEventsData(this.searchString);
    }
  }

  updateSearchEventsData(data) {
    if (data != undefined) {
      this.searchString = data;
      this.updateDefaultFilterType();
      this.searchComponent.updateSearchValue(this.searchString);
    } else {
      this.searchComponent.epSearchBox.clear();
    }


    if (this.searchString) {
      this.faDocumentService.getDataFromApi(this.documentType, this.customerId, this.searchString, 0, (documents: any, recordsCount: number) => {
        this.searchComponent.updateFilterValue(this.pageName, this.fromDashbard);
        if (documents && documents.length == 1) {
          this.navigateToDetailsView(documents[0]);
        } else {
          this.updateGridData();
        }
      });
    } else {
      this.searchComponent.updateFilterValue(this.pageName, this.fromDashbard);
      this.updateGridData();
    }
  }

  updateDefaultFilterType() {
    switch (this.pageName) {
      case SearchPageNames.CustomerOrders: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardOrdersSearchType = DefaultDocFilterType.OrderNumber;
          } else {
            this.filterService.selectedOrdersSearchType = DefaultDocFilterType.OrderNumber;
          }
          break;
        }
      case SearchPageNames.CustomerQuotes: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardQuotesSearchType = DefaultDocFilterType.QuoteNumber;
          } else {
            this.filterService.selectedQuotesSearchType = DefaultDocFilterType.QuoteNumber;
          }
          break;
        }
      case SearchPageNames.CustomerTempOrders: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardTempOrdersSearchType = DefaultDocFilterType.OrderNumber;
          } else {
            this.filterService.selectedTempOrdersSearchType = DefaultDocFilterType.OrderNumber;
          }
          break;
        }
      case SearchPageNames.CustomerCredit: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardCreditSearchType = DefaultDocFilterType.CreditNoteNumber;
          } else {
            this.filterService.selectedCreditSearchType = DefaultDocFilterType.CreditNoteNumber;
          }
          break;
        }
      case SearchPageNames.CustomerInvoices: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardInvoicesSearchType = DefaultDocFilterType.InvoiceNumber;
          } else {
            this.filterService.selectedInvoicesSearchType = DefaultDocFilterType.InvoiceNumber;
          }
          break;
        }
      case SearchPageNames.DashboardStockTranferSearch: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardstockTransfersSearchType = DefaultDocFilterType.OrderNumber;
          }
          break;
        }
      case SearchPageNames.DashboardPurchaseOrderSearch: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardPurchaseOrderSearchType = DefaultDocFilterType.PurchaseOrderNumber;
          }
          break;
        }
      case SearchPageNames.DashboardWorkOrderSearch: {
          if (this.fromDashbard) {
            this.filterService.selectedDashboardWorkOrderSearchType = DefaultDocFilterType.WorksOrderNumber;
          }
          break;
        }
      default:
        {
          break;
        }
    }
  }

  setSearchData() {
    switch (this.pageName) {
      case SearchPageNames.CustomerOpportunity: {
          this.searchString = this.filterService.opportunitySearchValue;
          break;
        }
      case SearchPageNames.CustomerOrders: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardOrdersSearchType == 'OrderNumber') {
              this.getSearchValues(this.filterService.ordersDashboardFilter, this.filterService.selectedDashboardOrdersSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          } else {
            if (this.filterService.selectedOrdersSearchType == 'OrderNumber') {
              this.getSearchValues(this.filterService.ordersFilter, this.filterService.selectedOrdersSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.CustomerQuotes: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardQuotesSearchType == 'QuoteNumber') {
              this.getSearchValues(this.filterService.quotesDashboardFilter, this.filterService.selectedDashboardQuotesSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          } else {
            if (this.filterService.selectedQuotesSearchType == 'QuoteNumber') {
              this.getSearchValues(this.filterService.quotesFilter, this.filterService.selectedQuotesSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.CustomerTempOrders: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardTempOrdersSearchType == 'OrderNumber') {
              this.getSearchValues(this.filterService.tempOrdersDashboardFilter, this.filterService.selectedDashboardTempOrdersSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          } else {
            if (this.filterService.selectedTempOrdersSearchType == 'OrderNumber') {
              this.getSearchValues(this.filterService.tempOrdersFilter, this.filterService.selectedTempOrdersSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.CustomerCredit: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardCreditSearchType == 'CreditNoteNumber') {
              this.getSearchValues(this.filterService.creditDashboardFilter, this.filterService.selectedDashboardCreditSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          } else {
            if (this.filterService.selectedCreditSearchType == 'CreditNoteNumber') {
              this.getSearchValues(this.filterService.creditFilter, this.filterService.selectedCreditSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.CustomerInvoices: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardInvoicesSearchType == 'InvoiceNumber') {
              this.getSearchValues(this.filterService.invoicesDashboardFilter, this.filterService.selectedDashboardInvoicesSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          } else {
            if (this.filterService.selectedInvoicesSearchType == 'InvoiceNumber') {
              this.getSearchValues(this.filterService.invoicesFilter, this.filterService.selectedInvoicesSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.CustomerCallOffOrders: {
          if (this.fromDashbard) {
            this.searchString = this.filterService.selectedDashboardCalloffCustomer;
          }
          break;
        }
      case SearchPageNames.CustomerStatements: {
          if (this.fromDashbard) {
            this.searchString = this.filterService.selectedDashboardStatementsCustomer;
          }
          break;
        }
      case SearchPageNames.DashboardStockTranferSearch: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardstockTransfersSearchType == 'OrderNumber') {
              this.getSearchValues(this.filterService.stockTransfersDashboardFilter, this.filterService.selectedDashboardstockTransfersSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.DashboardPurchaseOrderSearch: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardPurchaseOrderSearchType == 'PurchaseOrderNumber') {
              this.getSearchValues(this.filterService.purchaseOrderDashboardFilter, this.filterService.selectedDashboardPurchaseOrderSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      case SearchPageNames.DashboardWorkOrderSearch: {
          if (this.fromDashbard) {
            if (this.filterService.selectedDashboardWorkOrderSearchType == 'WorksOrderNumber') {
              this.getSearchValues(this.filterService.workOrderDashboardFilter, this.filterService.selectedDashboardWorkOrderSearchType);
            } else if (this.searchComponent && this.searchComponent.epSearchBox) {
              this.searchComponent.epSearchBox.clear();
 }
          }
          break;
        }
      default:
        {
          break;
        }
    }
  }

  getSearchValues(filters, selectedFilter) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    this.searchString = item ? item.searchValue : '';
  }

  getGridModel(documentList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'quoteNumber',
      selectedKeys: [],
    };

    this.gridColumns = [];

    this.faDocumentService.generateGridModelIEpGridColumn(this.documentType, ModelType.GridModel).forEach(element => {
      const row: IEpGridColumn = {
        field: element.field,
        title: element.title,
        width: element.width,
        hidden: element.hidden,
        editor: element.editor,
        cellTemplate: this.getTemplateType(element.type)
      };
      this.gridColumns.push(row);
    });

    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: documentList,
      columns: this.gridColumns,
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          if (eventArg.event.column.displayTitle != 'PDF') {
            this.navigateToDetailsView(eventArg.event.dataItem);
          }
        }
      },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridData(epGrid, state, false);
        return observerResult;
      }
    };
    return model;
  }
  getHeight(): number {
    const height = parseInt($('body').height());

    if (height > 900) {
      // return 300;
      return 700;
    } else { return 400; }// return 500;
  }

  getGridData(epGrid: EpGridComponent, state: IEpGridState, isMobile: boolean): Observable<IEPGridDataResult> {

    const observerResult = new Observable<IEPGridDataResult>(observer => {
      if (!isMobile) {
        epGrid.model.loadingIndicator = true;
      }
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.documentsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {

        if (this.documentType) {
          this.faDocumentService.getDataFromApi(this.documentType, this.customerId, this.searchString, state.skip, (documents: any, recordsCount: number) => {

            if (documents != null && documents != undefined && documents.length > 0) {
              this.totalPages = recordsCount;
              this.lastPage = Math.ceil(this.totalPages / state.take);
              if (pageNumber != this.lastPage) {
                this.pageArray.push(pageNumber);
              }

              if (!isMobile) {
                epGrid.model.loadingIndicator = false;
              }
              if (documents.length < state.take) {
                this.lastRecords = documents;
              } else {
                this.documentsCollection = [...this.documentsCollection, ...documents];
              }
              if (!isMobile) {
                this.mobileData = this.documentsCollection;
                if (this.lastRecords && this.lastRecords.length > 0) {
                  this.mobileData = [...this.mobileData, ...this.lastRecords];
                }
                this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
              }

              length = this.documentsCollection.length;
              const result: IEPGridDataResult = {
                data: documents,
                total: this.totalPages
              };
              observer.next(result);
              observer.complete();
            } else {
              const result: IEPGridDataResult = {
                data: [],
                total: 0
              };
              observer.next(result);
              observer.complete();
              if (!isMobile) {
                epGrid.model.loadingIndicator = false;
              }
              this.isMoreEnable = false;
              this.mobileData = this.mobileData ? this.mobileData : [];
            }
          });
        }
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  onValueChange(selectedValue: any): void {
    if (selectedValue) {
      this.documentType = selectedValue;
      this.pageName = this.documentType;
      if (!this.fromDashbard) {
        this.faDocumentService.selectedDocumentType = selectedValue;
      } else {
        this.faDocumentService.selectedDocumentTypeForDash = selectedValue;
      }

      this.documentTypeChange.emit(this.documentType);
      this.isFilter = true;
      this.isSort = true;
      this.onDocumentTypeChange(this.documentType);
      this.searchString = undefined;
      this.setSearchData();
      if (this.searchComponent) {
        this.searchComponent.updateSearchValue(this.searchString);
        this.searchComponent.updateFilterValue(this.pageName, this.fromDashbard);
      }
      this.card = this.faDocumentService.generateGridModelIEpGridColumn(this.documentType, ModelType.CardModel);
      // this.clearGridDetails();
      if (!this.fromDashbard || this.filterService.isFilterApplied(this.pageName, this.fromDashbard, true)) { // For grid Pre-initilazation
        this.clearGridDetails();
      } else {
        this.gridModel = undefined;
      }
      this.isMoreEnable = false;
    }
  }

  clearGridDetails() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.documentsCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
  }

  updateGridData() {
    if (this.documentType) {
      this.clearGridDetails();
    }
  }

  navigateToCustomer() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'searchString': this.searchString
      }
    };
    this.sortService.customerSearchValue = this.searchString;
    this.router.navigate(['/home/customer'], navigationExtras);
  }

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        // let contactsList;
        this.getGridData(epGrid, state, true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }

  navigateToDetailsView(args) {
    switch (this.documentType) {
      case DocumentTypes.Opportunities: {
          this.opportunityService.docOpportunity = new Opportunity();
          this.router.navigate(['/home/documents/addopportunity', this.customerId, args.opportunityID]);
          break;
        }
      case DocumentTypes.Quotes:
      case DocumentTypes.Orders:
      case DocumentTypes.TemplateOrders:
      case DocumentTypes.CallOffOrders:
      case DocumentTypes.Invoices:
      case DocumentTypes.Credits:
      case DocumentTypes.Stocktransfers:
      case DocumentTypes.PurchaseOrder:
      case DocumentTypes.WorkOrders: {
          EpDataViewModelService.current.add('selectedItem', [args]);
          this.router.navigate(['/home/documents/details', this.customerId]);
          console.log(args, 'selected items purchased orders');
          break;
        }
      case DocumentTypes.Statements: {
          this.faDocumentPDFService.IsIncludePaidTransactions = this.values.unCheck;
          this.onPDFDownloadClick(DocumentTypes.Statements, args);
          break;
        }
      default:
        {
          break;
        }
    }
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }


  // card model

  getList(model) {
    const data = [];
    if (model) {
      const list = Object.keys(model);
      if (this.card) {
        this.card.filter(i => {
          list.filter(k => {
            if (k == i.field) {
              data.push({
                key: i.displayName, value: model[i.field],
                icon: i.icon, isDate: i.isDate,
                isStatus: i.isStatus, isTitle: i.isTitle,
                isSubTitle: i.isSubTitle, isCurrency: i.isCurrency,
                isPercentage: i.isPercentage,
                isDownloadPDF: i.isDownloadPDF,
                isNumberWithNoComma: i.isNumberWithNoComma
              });
            }
          });
        });
      }
    }
    return data;
  }

  // Template Type
  getTemplateType(type: any): TemplateRef<any> {
    switch (type) {
      case GridFieldType.Date: return this.dateTemplate;
      case GridFieldType.Currency: return this.currencyTemplate;
      case GridFieldType.Percentage: return this.percentageTemplate;
      case GridFieldType.DownloadPDF: return this.downloadPDFTemplate;
      case GridFieldType.NumberWithNoComma: return this.noCommaTemplate;
      default: return null;
    }
  }

  onPDFDownloadClick(documentType: string, selectedDataItems: any) {
    console.log('order ID:' + JSON.stringify(selectedDataItems));
    this.faDocumentPDFService.processPDFDocumentForDownload(documentType, selectedDataItems);
  }

  addDocumentClick() {
    this.navigateTo();
  }

  navigateTo() {
    switch (this.documentType) {
      case DocumentTypes.Opportunities: {
          this.router.navigate(['/home/documents/addopportunity', this.customerId]);
          break;
        }
      case DocumentTypes.Quotes: {
          this.quickOrderService.quickOrder = new QuickOrderModel();
          if (this.customerService.selectedCustomer && !this.fromDashbard) {
            this.quickOrderService.quickOrder.customer = this.customerService.selectedCustomer;
            this.quickOrderService.fromDashbard = false;
            this.quickOrderService.selectedTransactionType = 2; // Quote
            this.quickOrderService.setCustomer(this.quickOrderService.quickOrder.customer, (flag: any) => {
              this.quickOrderService.SetDefaultTaxArea();
              if (this.fieldAgentService.isMobile) {
                this.router.navigate(['/home/quickorder']);
              } else {
                this.router.navigate(['/home/neworder']);
              }
            });
          } else {
            this.quickOrderService.clearData();
            this.customerService.selectedCustomer = null;
            this.quickOrderService.quickOrder = new QuickOrderModel();
            this.quickOrderService.fromDashbard = this.fromDashbard;
            this.quickOrderService.selectedTransactionType = 2;
            // this.router.navigate(['/home/quickorder']);
            if (this.fieldAgentService.isMobile) {
              this.router.navigate(['/home/quickorder']);
            } else {
              this.router.navigate(['/home/neworder']);
            }
          }
          break;
        }
      case DocumentTypes.Orders: {
          this.quickOrderService.quickOrder = new QuickOrderModel();
          if (this.customerService.selectedCustomer && !this.fromDashbard) {
            this.quickOrderService.quickOrder.customer = this.customerService.selectedCustomer;
            this.quickOrderService.fromDashbard = false;
            this.quickOrderService.selectedTransactionType = 1; // Order
            this.quickOrderService.setCustomer(this.quickOrderService.quickOrder.customer, (flag: any) => {
              this.quickOrderService.SetDefaultTaxArea();
              // this.router.navigate(['/home/quickorder']);
              if (this.fieldAgentService.isMobile) {
                this.router.navigate(['/home/quickorder']);
              } else {
                this.router.navigate(['/home/neworder']);
              }
            });
          } else {
            this.quickOrderService.clearData();
            this.customerService.selectedCustomer = null;
            this.quickOrderService.quickOrder = new QuickOrderModel();
            this.quickOrderService.fromDashbard = this.fromDashbard;
            this.quickOrderService.selectedTransactionType = 1;
            // this.router.navigate(['/home/quickorder']);
            if (this.fieldAgentService.isMobile) {
              this.router.navigate(['/home/quickorder']);
            } else {
              this.router.navigate(['/home/neworder']);
            }
          }
          break;
        }
      case DocumentTypes.TemplateOrders:
      case DocumentTypes.CallOffOrders:
      case DocumentTypes.Invoices:
      case DocumentTypes.Credits:
      case DocumentTypes.Statements:
      case DocumentTypes.Stocktransfers:
      case DocumentTypes.PurchaseOrder: {
          break;
        }
      default:
        {
          break;
        }
    }

  }

  onDocumentTypeChange(documentType: any) {
    this.documentType = documentType;
    switch (documentType) {
      case DocumentTypes.Opportunities: {
          this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
            if (bistrackSettings && bistrackSettings.licensing.crmEnabled) {
              this.fieldAgentService.checkAddPermissions(Right.EditOpportunities, (flag: any) => {
                this.addVisibility = flag;
              }, Right.ViewOpportunities);
            } else {
              this.addVisibility = false;
            }
          });

          // this.addVisibility = true;
          this.addButtonTitle = 'ADD OPPORTUNITY';
          this.placeholder = SearchPlaceHolderText.Opportunities;
          break;
        }
      case DocumentTypes.Quotes: {
          this.fieldAgentService.checkAddPermissions(Right.CreateQuotes, (flag: any) => {
            this.addVisibility = flag;
          }, Right.ViewQuotes);
          // this.addVisibility = true;
          this.addButtonTitle = 'ADD QUOTE';
          this.placeholder = SearchPlaceHolderText.Quote;
          break;
        }
      case DocumentTypes.Orders: {
          this.fieldAgentService.checkAddPermissions(Right.PlaceOrders, (flag: any) => {
            this.addVisibility = flag;
          }, Right.ViewOrders);
          // this.addVisibility = true;
          this.addButtonTitle = 'ADD ORDER';
          this.placeholder = SearchPlaceHolderText.Order;
          break;
        }
      case DocumentTypes.TemplateOrders: {
          this.addVisibility = false;
          this.placeholder = SearchPlaceHolderText.Order;
          break;
        }
      case DocumentTypes.CallOffOrders: {
          this.addVisibility = false;
          this.isFilter = this.fromDashbard ? true : false;
          this.isSort = false;
          this.placeholder = SearchPlaceHolderText.Customer;
          break;
        }
      case DocumentTypes.Invoices: {
          this.addVisibility = false;
          this.placeholder = SearchPlaceHolderText.Invoice;
          break;
        }
      case DocumentTypes.Credits: {
          this.addVisibility = false;
          this.placeholder = SearchPlaceHolderText.Credit;
          break;
        }
      case DocumentTypes.Statements: {
          this.addVisibility = false;
          this.isFilter = this.fromDashbard ? true : false;
          this.placeholder = SearchPlaceHolderText.Customer;
          break;
        }
      case DocumentTypes.Stocktransfers: {
          this.addVisibility = false;
          this.isFilter = this.fromDashbard ? true : false;
          this.isSort = this.fromDashbard ? true : false;
          this.placeholder = SearchPlaceHolderText.Stocktransfer;
          break;
        }
      case DocumentTypes.PurchaseOrder: {
          this.addVisibility = false;
          this.isFilter = this.fromDashbard ? true : false;
          this.isSort = false;
          this.placeholder = SearchPlaceHolderText.PurchaseOrder;
          break;
        }
      case DocumentTypes.WorkOrders: {
          this.addVisibility = false;
          this.isFilter = this.fromDashbard ? true : false;
          this.isSort = false;
          this.placeholder = SearchPlaceHolderText.WorkOrders;
          break;
        }
      default:
        {
          break;
        }
    }
  }
}
